import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { adminFetchCompanies } from "../api/companies.api";

interface UseAdminCompaniesProps {
  includeOrganizations?: boolean;
  enabled?: boolean;
}

const useAdminCompanies = ({
  includeOrganizations,
  enabled = true,
}: UseAdminCompaniesProps) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  // Fetch all companies for user
  const {
    data: companiesData,
    error: companiesError,
    isLoading: isLoadingCompanies,
    isSuccess: isCompaniesSuccess,
  } = useQuery({
    queryKey: ["adminCompanies", includeOrganizations],
    queryFn: () =>
      adminFetchCompanies(bearerToken as string, includeOrganizations),
    enabled: !!bearerToken && enabled,
  });

  return {
    companies: companiesData,
    companiesError,
    isLoadingCompanies,
    isCompaniesSuccess,
  };
};

export default useAdminCompanies;
